<template>
  <v-app-bar
    app
    clipped-left
    :style="{ backgroundColor: color }"
    :dark="isThemeDark"
    elevation="0"
    outlined
  >
    <v-app-bar-nav-icon @click.stop="onMenuClicked"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <CompanyButton class="mr-10" />
    <ThemeSwitch />
    <NotificationButton />

    <UserProfileButton />
    <v-divider
      class="ml-1"
      vertical
    ></v-divider>
    <LanguagesSwitch />
  </v-app-bar>
</template>

<script>
import { getTheme } from "@/plugins/vuetify"

export default {
  name: "AppBar",
  components: {
    CompanyButton: () => import("@/components/generics/buttons/CompanyButton.vue"),
    LanguagesSwitch: () => import("@/components/inputs/LanguagesSwitch.vue"),
    NotificationButton: () => import("@/components/generics/buttons/NotificationButton.vue"),
    ThemeSwitch: () => import("@/components/inputs/ThemeSwitch.vue"),
    UserProfileButton: () => import("@/components/generics/buttons/UserProfileButton.vue")
  },
  data() {
    return {
      toNotificationPage: { name: "NotificationsPage" }
    }
  },
  computed: {
    color() {
      return getTheme(this).bgAppBar
    },
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    },
    title() {
      return this.$t(`nav.title.${this.$route.name}`)
    }
  },
  methods: {
    onMenuClicked() {
      this.$emit("toggle")
    }
  }
}
</script>

<style scoped>
#app-navbar {
  border-color: grey;
}
</style>
